import { ClientsService } from '@services/clients.service';
import { OrdersService } from '@services/orders.service';
import { UiService } from '@services/ui.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from '@classes/user/user';
import { Client } from '@classes/client';
import { DomSanitizer } from '@angular/platform-browser';

export interface DialogData {
  client: Client,
  urlImg: string
}

@Component({
  selector: 'app-dialog-logo-client',
  templateUrl: './dialog-logo-client.component.html',
  styleUrls: ['./dialog-logo-client.component.scss']
})
export class DialogLogoClientComponent implements OnInit {
  fileAttr = 'Choisir un fichier';
  selectedFile: File = null;
  isLoadingFile = false;

  thumbnail: any;

  constructor(
    public dialogRef: MatDialogRef<DialogLogoClientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private uiSrv: UiService,
    private sanitizer: DomSanitizer,
    private clientsSrv: ClientsService
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    if (this.data.urlImg) {
      this.thumbnail = this.sanitizer.bypassSecurityTrustUrl(this.data.urlImg);
    }
  }

  confirmDriverChange(): void {
    // this.ordersSrv.assignDriver(this.data.orderId, this.driverForm.value.driver, this.driverForm.value.comment)
    //   .subscribe(() => {
    //     this.uiSrv.showSnackbar('orders.edit.reassigned', true);
    //     this.onNoClick();
    //   })

  }

  chooseFile(file: any) {
    this.isLoadingFile = true;
    const selFile: File = file.target.files[0];
    this.selectedFile = selFile;

    this.isLoadingFile = false;
  }

  uploadFile() {
    this.isLoadingFile = true;
    this.clientsSrv.putPhoto(this.selectedFile, this.data.client.id).subscribe(() => {
      this.isLoadingFile = false;
      this.uiSrv.showSnackbar('Logo uploadé avec succès', false);
      this.data.client.hasLogo = true;
      this.selectedFile = null;
      this.onNoClick();
    });
  }

  clearFileSelected() {
    this.selectedFile = null;
  }


}
